import {
  UNIT_TRUST_INVESTMENT_ACCOUNT,
  EQUITY_INVESTMENT_ACCOUNT,
  STRUCTURED_PRODUCTS_ACCOUNT,
  BONDS_ACCOUNT,
  HSBC_CONVENTIONAL_UT_ACCOUNT,
  HSBC_AMANAH_UT_ACCOUNT,
} from 'srcAlias/client/enums/productDescriptionCode';
import {
  UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY,
  EQUITY_INVESTMENT_ACCOUNT_CATEGORY,
  STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY,
  BONDS_ACCOUNT_CATEGORY,
} from 'srcAlias/client/enums/productCategory';
export const getProductTypeLabels = {
  [`${EQUITY_INVESTMENT_ACCOUNT}_${EQUITY_INVESTMENT_ACCOUNT_CATEGORY}`]: {
    labelText: 'equityLabelText',
    helpText: 'equityHelpText',
  },
  [`${UNIT_TRUST_INVESTMENT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`]:
    {
      labelText: 'unitTrustLabelText',
      helpText: 'unitTrustHelpText',
    },
  [`${STRUCTURED_PRODUCTS_ACCOUNT}_${STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY}`]: {
    labelText: 'structuredProductsLabelText',
    helpText: 'structuredProductsHelpText',
  },
  [`${BONDS_ACCOUNT}_${BONDS_ACCOUNT_CATEGORY}`]: {
    labelText: 'bondsLabelText',
    helpText: 'bondsHelpText',
  },
  [`${HSBC_CONVENTIONAL_UT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`]:
    {
      labelText: 'conventionalUnitTrustLabelText',
      helpText: 'conventionalUnitTrustHelpText',
    },
  [`${HSBC_AMANAH_UT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`]: {
    labelText: 'amanahUnitTrustLabelText',
    helpText: 'amanahUnitTrustHelpText',
  },
};
